"use strict";

var _classCallCheck = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeNames_1 = require("../enum/NodeNames");

var ParamNames_1 = require("../enum/ParamNames");

var ParseError_1 = require("../errors/ParseError");

var AbstractAssign_1 = require("./abstract/AbstractAssign");

var SettingNode =
/*#__PURE__*/
function (_AbstractAssign_1$def) {
  _inherits(SettingNode, _AbstractAssign_1$def);

  function SettingNode(token) {
    var _this;

    _classCallCheck(this, SettingNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SettingNode).call(this, NodeNames_1.default.Setting, token));

    var params = _this.checkParams(token);

    if (params.length === 1) {
      var param = params[0];

      if (param.type === ParamNames_1.default.AssignmentExpression) {
        _this.expression = param;
        return _possibleConstructorReturn(_this);
      }
    }

    throw new ParseError_1.default("Invalid parameters in ".concat(_this.type), token);
    return _this;
  }

  return SettingNode;
}(AbstractAssign_1.default);

exports.default = SettingNode;